/** A delicate golden divider with a central sparkle — a small storybook flourish. */
export function Flourish() {
  return (
    <div
      className="flex items-center justify-center gap-3 text-ouro/70"
      aria-hidden="true"
    >
      <span className="h-px w-12 bg-gradient-to-r from-transparent to-ouro/50" />
      <span className="text-sm">✦</span>
      <span className="h-px w-12 bg-gradient-to-l from-transparent to-ouro/50" />
    </div>
  );
}
